import { Box, Drawer, Typography } from '@mui/material';
import { protoIcon } from './ProtoIcon';
import React from 'react';

/**
 * Folha de baixo do shell mobile — `.sheet` de `prototipos-mobile/assets/mobile.css`:
 * raio 24 24 0 0, alça 40x4, cabeçalho (h3 17/800 + fechar 40x40), corpo rolável
 * e rodapé opcional (`footer`) com borda superior. Fundo escurecido rgba(10,14,26,.5).
 *
 * Só para o shell mobile; o desktop continua com seus diálogos/menus.
 */
const X = protoIcon('x');

export const SHEET_CLOSE_BUTTON_SX = {
    width: 40,
    height: 40,
    minWidth: 40,
    minHeight: 40,
    borderRadius: '12px',
    border: 0,
    background: 'transparent',
    padding: 0,
    color: 'text.secondary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    cursor: 'pointer',
    '&:active': { backgroundColor: 'background.subtle' },
};

export default function MobileSheet({ open, onClose, title, children, footer, bodySx, actionList = false }) {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            ModalProps={{ keepMounted: false }}
            slotProps={{
                backdrop: { sx: { backgroundColor: 'rgba(10,14,26,.5)' } },
                paper: {
                sx: {
                    maxHeight: '88%',
                    borderRadius: '24px 24px 0 0',
                    backgroundColor: 'background.paper',
                    backgroundImage: 'none',
                    boxShadow: (theme) => (theme.palette.mode === 'dark' ? '0 24px 60px rgba(0,0,0,.55)' : '0 20px 50px rgba(15,23,42,.18)'),
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                },
                },
            }}
        >
            <Box sx={{ width: 40, height: 4, borderRadius: '2px', backgroundColor: 'divider', m: '8px auto 2px', flexShrink: 0 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: '8px 16px 8px 20px', flexShrink: 0 }}>
                <Typography component="h3" sx={{ fontSize: 17, fontWeight: 800, lineHeight: 1.4 }}>{title}</Typography>
                <Box component="button" type="button" aria-label="Fechar" onClick={onClose} sx={SHEET_CLOSE_BUTTON_SX}>
                    <X size={20} />
                </Box>
            </Box>
            <Box
                sx={{
                    p: '6px 16px 16px',
                    overflowY: 'auto',
                    ...(actionList ? { '& .sheet-item': { border: 0, p: '12px 4px' } } : {}),
                    ...bodySx,
                }}
            >
                {children}
            </Box>
            {footer && (
                <Box sx={{ display: 'flex', gap: '10px', p: '12px 16px calc(14px + env(safe-area-inset-bottom, 0px))', borderTop: '1px solid', borderColor: 'divider', flexShrink: 0 }}>
                    {footer}
                </Box>
            )}
        </Drawer>
    );
}
